import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { CreateContactGroupParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListContactGroups } from "../queries/useListContactGroups";

export const CreateContactGroup = graphql(/* GraphQL */ `
	mutation CreateContactGroup($params: CreateContactGroupParams!) {
		createContactGroup(params: $params) {
			success
			error {
				code
				message
			}
			contactGroup {
				gid
			}
		}
	}
`);

export function useCreateContactGroup() {
	const [createContactGroup] = useMutation(CreateContactGroup, {
		refetchQueries: [ListContactGroups],
	});

	const handleCreateContactGroup = useCallback(
		async (params: CreateContactGroupParams) => {
			const result = await createContactGroup({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.createContactGroup.success,
				error: result.data?.createContactGroup.error,
				gid: result.data?.createContactGroup.contactGroup?.gid,
			};
		},
		[createContactGroup]
	);

	return { handleCreateContactGroup };
}
